import Button from "@/lib/Button";
import Input from "@/lib/Input";
import { useState } from "react";
import Layout from "./Layout";
import StyledLink from "@/lib/StyledLink";
import PasswordHint from "@/lib/PasswordHint";
import $api from "@/lib/queries/openapi";
import { useSearchParams } from "react-router";
import { useQueryClient } from "@tanstack/react-query";

export default function Signup() {
  const queryClient = useQueryClient();
  const [agreed, setAgreed] = useState(true);
  const [password, setPassword] = useState("");
  const passwordValid = password.length;

  const [searchParams] = useSearchParams();
  const invitationSecret = searchParams.get("invitation-secret") || "";
  const invitationId = searchParams.get("invitation-id") || "";
  const { data } = $api.useQuery("get", "/api/invitation", {
    params: { query: { secret: invitationSecret, id: invitationId } },
    enabled: invitationSecret.length > 0,
  });

  const { mutate: signupWithInvitation } = $api.useMutation(
    "post",
    "/api/auth/signup",
    {
      onSuccess: () => {
        queryClient.invalidateQueries();
      },
    },
  );

  return (
    <Layout title="Create an Account">
      <>
        <Input
          label="Email"
          value={data?.email ?? ""}
          onChange={() => {}}
          type="email"
          placeholder="Email"
          name="email"
          disabled={true}
        />
        <Input
          label="Password"
          value={password}
          onChange={setPassword}
          type="password"
          placeholder="Password"
          disabled={!data?.email}
        />
        <Button
          primary
          size="lg"
          disabled={!data?.email || !passwordValid || !agreed}
          onClick={() => {
            signupWithInvitation({
              body: {
                email: data?.email ?? "",
                password,
                invitation_secret: invitationSecret,
              },
            });
          }}
        >
          {data?.email
            ? "Sign Up"
            : "Sign Up is only available with invitation"}
        </Button>
        <PasswordHint />
        <label className="flex gap-2 select-none">
          <input
            type="checkbox"
            checked={agreed}
            onChange={(e) => setAgreed(e.target.checked)}
          />
          <div>
            I agree to <StyledLink to="">Terms & Conditions</StyledLink> and{" "}
            <StyledLink to="">Privacy Policy</StyledLink>
          </div>
        </label>
      </>
    </Layout>
  );
}
